export default __webpack_public_path__ + "static/media/Ed3amnyEd3amny.4ed70afc.png";